import { File } from "@/backend/models/file";

export enum CommandingRunStages {
  INPUT = 'input',
  OUTPUT = 'output',
}

export interface CommandingRunTaskCreateParams {
  alias: string;
  commandingRunId: string;
  stage: CommandingRunStages;
  taskOrder: number;
  taskResponseYaml?: string;
  runState: RUN_STATE;
  statusMessage?: string;
  startTime?: Date | string;
}

export interface CommandingRunTaskData extends CommandingRunTaskCreateParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  asset?: File;
  /** The org of the task's run. CommandingRunTaskAccess sets it on create from the writer org; callers never choose it. */
  propelOrgId?: string;
};

export enum RUN_STATE {
  COMPLETED = 'completed',
  ERROR = 'errored',
  CREATED = 'created',
  EMPTY = '',
  RUNNING = 'running',
  CANCELLED = 'cancelled',
};